import axios, { AxiosError } from "axios";
import { useMutation } from "react-query";
import { SecureAnnouncementUploadRequest } from "../request/SecureAnnouncementUploadRequest";
import { SecureAnnouncementUploadResponse } from "../model/SecureAnnouncementUploadResponse";

const SecureAnnouncementUploadApiService = async (
  request: SecureAnnouncementUploadRequest
): Promise<SecureAnnouncementUploadResponse> => {
  const url = "/utils/generate_url_for_secure_upload/";
  const formData = new FormData();

  // Append all request parameters to FormData
  Object.entries(request).forEach(([key, value]) => {
    formData.append(key, value);
  });

  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  };

  const { data } = await axios.post(url, formData, config);
  return data;
};

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const useSecureAnnouncementUploadApiService = () =>
  useMutation<
    SecureAnnouncementUploadResponse,
    AxiosError,
    SecureAnnouncementUploadRequest
  >(SecureAnnouncementUploadApiService, {
    mutationKey: "SecureAnnouncementUploadApiService",
  });

export default useSecureAnnouncementUploadApiService;
export type { SecureAnnouncementUploadRequest } from "../request/SecureAnnouncementUploadRequest";
export type { SecureAnnouncementUploadResponse } from "../model/SecureAnnouncementUploadResponse";
